/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* Images */
import icoBreak from "../../../asset/img/break.svg"
import icoThief from "../../../asset/img/thief.svg"
import icoUpgrade from "../../../asset/img/upgrade.svg"

/* Utils */
import { loc } from "../../../core/utils"
import { getStaticDocUrl } from "../../../utils/staticDocumentUrls"
import "./styles/staticComponentStyle.css"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function StaticComponent({ tunnelData }) {
  const hrefContract = getStaticDocUrl(tunnelData, "contract", "https://static-it.evollis.com/contract_it.pdf")
  const hrefServices = getStaticDocUrl(tunnelData, "services", "https://static-it.evollis.com/services_it.pdf")

  return (
    <Row className="justify-content-center">
      <Col sm={12}>
        <h2 className="text-center margin-bottom-32 margin-top-40">{loc`Summary of services included `}</h2>
      </Col>
      <Col className="services-included-block text-center hard-shadow-white-block m-2" md={4} sm={12} lg={3}>
        <span className="services-included-ico">
          <img src={icoUpgrade} alt="icon upgrade" />
        </span>
        <h3>Upgrade</h3>
        <p>Opzione di cambio Prodotto a partire dal 12° mese</p>
        <p className="black-p">
          Per le specifiche condizioni e caratteristiche del servizio clicca qui{" "}
          <a href={hrefContract} target="_blank" rel="noopener noreferrer" alt="Contratto pdf file">
            {" "}
            termini e condizioni del contratto
          </a>
        </p>
      </Col>
      <Col className="services-included-block text-center hard-shadow-white-block m-2" md={4} sm={12} lg={3}>
        <span className="services-included-ico">
          <img src={icoBreak} alt="icon break" />
        </span>
        <h3>Servizio di assistenza, con riparazione in caso di Danni e Malfunzionamenti</h3>
        <p>(Contributo all’attivazione di € 0 solo per Danni)</p>
        <p className="black-p">
          Per le specifiche condizioni e caratteristiche del servizio clicca qui{" "}
          <a href={hrefServices} target="_blank" rel="noopener noreferrer" alt="">
            riepilogo dei servizi inclusi
          </a>
        </p>
      </Col>
      <Col className="services-included-block text-center hard-shadow-white-block m-2" md={4} sm={12} lg={3}>
        <span className="services-included-ico">
          <img src={icoThief} alt="icon thief" />
        </span>
        <h3>Servizio di assistenza, con sostituzione in caso di Furto</h3>
        <p>(Contributo all’attivazione di € 0)</p>
        <p className="black-p">
          Per le specifiche condizioni e caratteristiche del servizio clicca qui{" "}
          <a href={hrefServices} target="_blank" rel="noopener noreferrer" alt="">
            riepilogo dei servizi inclusi
          </a>
        </p>
      </Col>
    </Row>
  )
}
